import React, { useState, useEffect } from "react";
import {
  Container,
  TextField,
  Button,
} from "@mui/material";
import Header2 from "./Header2";
import { updateUser, auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";

const Edit = () => {
  const [displayName, setDisplayName] = useState("");
  const [phone, setPhone] = useState("");
  const [point, setPoint] = useState("");

  const handleDisplayNameChange = (event) => {
    setDisplayName(event.target.value);
  };

  const handlePhoneChange = (event) => {
    setPhone(event.target.value);
  };

  const handlePointChange = (event) => {
    setPoint(event.target.value);
  };

  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
    });

    return () => unsubscribe();
  }, []);

  const handleSubmit = () => {
    updateUser(user.uid, displayName, phone, point);
  };

  return (
    <Container>
      <Header2/>
      <Container sx={{ mt: 16 }}>
        <Container
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            width: "100%",
            textAlign: "left",
            marginTop: "20px",
          }}
        >
          <TextField
            label="Nombre"
            variant="outlined"
            value={displayName}
            onChange={handleDisplayNameChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Teléfono"
            variant="outlined"
            value={phone}
            onChange={handlePhoneChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Localidad"
            variant="outlined"
            value={point}
            onChange={handlePointChange}
            fullWidth
            margin="normal"
          />
          <Button
            sx={{ marginTop: 2 }}
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            Guardar cambios
          </Button>
        </Container>
      </Container>
    </Container>
  );
};

export default Edit;
